import { render } from "./2.GetInTouch.vue?vue&type=template&id=b16c5378&scoped=true"
import script from "./2.GetInTouch.vue?vue&type=script&lang=js"
export * from "./2.GetInTouch.vue?vue&type=script&lang=js"

import "./2.GetInTouch.vue?vue&type=style&index=0&id=b16c5378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b16c5378"]])

export default __exports__